import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type QuotationMapHeaderSkeletonSection = 'title' | 'actions' | 'bestPriceToggle';

@Component({
  selector: 'aionz-quotation-map-header-skeleton',
  templateUrl: './quotation-map-header-skeleton.component.html',
  styleUrl: './quotation-map-header-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuotationMapHeaderSkeletonComponent {
  section = input.required<QuotationMapHeaderSkeletonSection>();
}
